moneyMoveForm = function(urlSend, urlReminder) {
    return {
        urlSend,
        urlReminder,
        isSubmitting: false,
        isTurnstileReady: false,
        error: null,
        recommendation: null,
        result: null,
        isResultValid: false,
        reminderEmail: '',
        reminderError: '',
        isReminderSubmitting: false,
        isReminderSent: false,

        init() {
            global.onTurnstileReadyHandler(() => this.isTurnstileReady = true);
        },

        setFile() {
            document.getElementById('fileInput').click();
        },
        afterFileUpload(e) {
            this.isSubmitting = true;
            const fileEl = global.cloneFileInput(e);
            const afterLoad = (data) => {
                this.isTurnstileReady = false;
                global.resetTurnstile();
                this.fileListLoading = false;
                this.isSubmitting = false;
                if (data) {
                    if (data.error) {
                        this.error = data.error;
                        this.recommendation = data.recommendation;
                    } else {
                        this.error = null;
                        this.recommendation = null;
                        this.result = data.html;
                        this.isResultValid = !!data.isValid;
                        global.yandexGoal('money_move_file_added');
                    }
                }
                e.target.value = null;
            }
            if (fileEl.value) {
                const xhr = new XMLHttpRequest();
                xhr.open("POST", urlSend);
                xhr.onload = function(e){
                    let resp;
                    if (e.target.status === 413) {
                        resp = {error: 'Файл слишком большой', recommendation: 'Скорее всего вы загружаете не CSV-отчет, а чтото другое. Убедитесь, что у загружаемого файла расширение csv.'};
                    } else if (e.target.status !== 200) {
                        resp = {error: e.target.statusText};
                    } else {
                        resp = JSON.parse(e.target.response);
                    }
                    afterLoad(resp);
                };
                xhr.onerror = function(e){
                    afterLoad({error: e.target.statusText});
                };
                const form = document.createElement('form');
                const tokenEl = document.createElement('input');
                tokenEl.type = 'hidden';
                tokenEl.name = 'token';
                tokenEl.value = global.turnstileToken;
                form.appendChild(fileEl);
                form.appendChild(tokenEl);
                const formData = new FormData(form);
                xhr.send(formData);
            } else {
                afterLoad();
            }
        },
        closeResult() {
          this.result = null;
          this.isResultValid = false;
        },
        isResultNonEmptyAndValid() {
            return this.result && this.isResultValid;
        },
        sendReminder() {
            this.reminderError = '';
            if (!this.reminderEmail) {
                this.reminderError = 'Введите e-mail';
                return;
            }
            if (!this.isTurnstileReady || this.isReminderSubmitting) {
                return;
            }

            this.isReminderSubmitting = true;
            const clientUuid = getOrCreateClientUuid();
            fetch(this.urlReminder, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-id': clientUuid,
                },
                body: JSON.stringify({
                    token: global.turnstileToken,
                    email: this.reminderEmail,
                }),
            }).then(x => x.json()).then(x => {
                this.isTurnstileReady = false;
                global.resetTurnstile();
                this.isReminderSubmitting = false;
                if (x.error) {
                    this.reminderError = x.error;
                } else {
                    this.isReminderSent = true;
                    global.yandexGoal('money_move_result_reminder_email');
                }
            }).catch(() => {
                this.isReminderSubmitting = false;
                this.reminderError = 'Не удалось сохранить e-mail. Попробуйте еще раз.';
            });
        },
    }
}

function getOrCreateClientUuid() {
    const existId = localStorage.getItem('id');
    if (existId) {
        return existId;
    }
    const newId = generateUUID();
    localStorage.setItem('id', newId);
    return newId;
}

function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
